export enum NotificationType {
    TASK_ASSIGNED = 'TASK_ASSIGNED',
    COMPANY_ASSIGNED = 'COMPANY_ASSIGNED',
    MENTION = 'MENTION',
    TASK_READY_FOR_REVIEW = 'TASK_READY_FOR_REVIEW',
    TASK_REJECTED = 'TASK_REJECTED',
    DEADLINE_APPROACHING = 'DEADLINE_APPROACHING',
    /**
     * REV-21374 — eine Erwaehnung in einem ABCP-Kommentar oder einer Pendenz.
     *
     * ⚠️ Eigener Typ statt `MENTION`: `MENTION` traegt eine `taskId` und fuehrt nach CPMM.
     * Unter demselben Typ laege die Unterscheidung allein daran, welche Felder zufaellig
     * gesetzt sind — und der Klick landete auf einer plausibel aussehenden falschen Seite.
     * Muss mit dem Enum in `aumico-be` uebereinstimmen.
     */
    NOTE_MENTION = 'NOTE_MENTION',
}
